export default "__VITE_ASSET__BSlfgd5l__"